// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"668b4fc3","239":"b74f4ae0","453":"d9dbaf1f","455":"a86d1ba1"}[chunkId] + ".chunk.js";
};